import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c3b02cd8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-socket-values" };
import { computed } from "vue";
import RewardSupplierDisplayName from "./RewardSupplierDisplayName.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RewardSupplierIdListVariableBuiltValue',
    props: {
        value: {}
    },
    setup(__props) {
        const props = __props;
        const isStringList = (value) => {
            return (Array.isArray(value) && value.every((item) => typeof item === "string"));
        };
        const selectionsProxy = computed(() => {
            return isStringList(props.value) ? props.value : [];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectionsProxy.value, (selection) => {
                    return (_openBlock(), _createBlock(RewardSupplierDisplayName, {
                        key: selection,
                        rewardSupplierId: selection
                    }, null, 8 /* PROPS */, ["rewardSupplierId"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
